import { cn } from "../../lib/utils";
import {
  isFailedStatus,
  isSuccessStatus,
} from "../../lib/communicationLogUtils";

export function TypeBadge({ value }: { value?: string }) {
  if (!value || value === "—") {
    return <span className="text-muted-foreground">—</span>;
  }
  return (
    <span
      className={cn(
        "inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium capitalize",
        "bg-blue-50 text-blue-700"
      )}
    >
      {value.replace(/_/g, " ")}
    </span>
  );
}

export function StatusBadge({ status }: { status?: string }) {
  if (!status || status === "—") {
    return <span className="text-muted-foreground">—</span>;
  }
  const normalized = status.toLowerCase();
  return (
    <span
      className={cn(
        "inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium capitalize",
        isSuccessStatus(normalized) && "bg-emerald-50 text-emerald-700",
        isFailedStatus(normalized) && "bg-red-50 text-red-700",
        !isSuccessStatus(normalized) &&
          !isFailedStatus(normalized) &&
          "bg-slate-100 text-slate-600"
      )}
    >
      {normalized.replace(/_/g, " ")}
    </span>
  );
}

export function HttpOkBadge({ code }: { code?: string | number }) {
  const num = Number(code);
  if (Number.isNaN(num)) {
    return null;
  }
  const ok = num >= 200 && num < 300;
  return (
    <span
      className={cn(
        "inline-flex rounded px-2 py-0.5 text-xs font-medium",
        ok ? "bg-emerald-50 text-emerald-700" : "bg-red-50 text-red-700"
      )}
    >
      {ok ? "HTTP OK" : "HTTP Error"}
    </span>
  );
}
